import { useState } from "react";
import { GetScrapFinanceAccountsResponseModel } from "@/features/accounts/scrap-finance/services/get-accounts-model";


export const useGetScrapFinanceAccountStates = () => {
  const [institutionType, setInstitutionType] = useState("");
  const [scrapFinanceAccountId, setScrapFinanceAccountId] = useState("");
  const [scrapFinanceAccounts, setScrapFinanceAccounts] = useState<GetScrapFinanceAccountsResponseModel[]>([]);

  // エラーダイアログ表示フラグ情報
  const [isShowErrorDialog, setIsShowErrorDialog] = useState({
    isError: false,
    errorMessage: "",
    errorCode: "",
  });

  return {
    institutionType,
    setInstitutionType,
    scrapFinanceAccountId,
    setScrapFinanceAccountId,
    scrapFinanceAccounts,
    setScrapFinanceAccounts,
    isShowErrorDialog,
    setIsShowErrorDialog,
  };
};
